import React, { useState } from "react";
import "../CSS/home.css";
import "animate.css/animate.min.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsFillTelephoneFill,
  BsSendFill,
} from "react-icons/bs";
import Loader from "../COMPONENT/Loader";
import logo from "../Images/logo.png";
import img1 from "../Images/img1.png";
import img2 from "../Images/img2.png";
import img3 from "../Images/img3.png";
import img4 from "../Images/img4.png";
import img5 from "../Images/google_play.png";
import img6 from "../Images/ecommerce.png";
import img7 from "../Images/demo.png";
import img8 from "../Images/qrcode.png";
import img9 from "../Images/planto.png";

function Home() {
  const navigate = useNavigate();
  const handleDemo = () => {
    navigate("/demostore");
  };
  React.useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_API}/send-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, phone, email, msg }),
        }
      );
      setLoading(false);
      if (response.status === 200) {
        alert("Thank you! Your message has been sent successfully.");
        setName("");
        setPhone("");
        setEmail("");
        setMsg("");
      } else {
        alert("Oops! It seems there was an issue. Please try again later.");
      }
    } catch (error) {
      //console.error("Error sending email:", error);
      alert("Oops! It seems there was an issue. Please try again later.");
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ overflow: "hidden" }}>
            <div className="bazaar-logo-container">
              <img src={logo} alt="Bazaar-logo" className="bazaar-logo" />
              <h3>#BazaarForBharat</h3>
            </div>

            <div className="hero-image-section">
              <div className="hero-image-section-background"></div>
              <div className="img1_container">
                <img
                  src={img2}
                  alt="Mobile mockup"
                  className="img1 animate__animated animate__fadeInLeft"
                />
              </div>
              <div className="img2_container">
                <img
                  src={img3}
                  alt="Mobile mockup"
                  className="img2 animate__animated animate__zoomIn"
                />
              </div>
              <div className="img3_container">
                <img
                  src={img1}
                  alt="Mobile mockup"
                  className="img3 animate__animated animate__fadeInRight"
                />
              </div>
            </div>

            <div className="bazaar-app-description-container">
              <div className="bazaar-app-description-text" data-aos="fade-up">
                <h2>Take Your Business Online with Bazaar</h2>
                <h4>
                  Start Your Online Business for FREE and Reach More Customers!
                </h4>
                <a href="https://play.google.com/store/apps/details?id=com.bazaarappin">
                  <img
                    src={img5}
                    alt="google play store"
                    className="google-play-store"
                  />
                </a>
              </div>
              <div className="bazaar-app-description-image" data-aos="fade-up">
                <img src={img4} alt="Mobile mockup" />
              </div>
            </div>

            <div class="website-mockup-section">
              <h2 data-aos="fade-up">Create your free e-commerce website in just few seconds!</h2>
              <button data-aos="fade-up">Let's create</button>
              <img src={img9} alt="mockup" data-aos="zoom-out-up"/>
            </div>

            <div className="bazaar-function-text" data-aos="zoom-out-up">
              <h1>What all can you do with Bazaar?</h1>
              <div className="line"></div>
            </div>
            <div
              className="bazaar-all-function-list-container"
              data-aos="fade-up"
            >
              <div className="function-container">
                <h2>Create digital store</h2>
                <div className="line2"></div>
                <p>
                  With Bazaar app, you can easily create your online store.
                  Simply provide your business name and category, and our
                  platform will generate a professional website, allowing you to
                  display catalogs and grow your online presence effortlessly.
                </p>
              </div>
              <div className="function-container">
                <h2>Add catalogs and categories</h2>
                <div className="line2"></div>
                <p>
                  Effortlessly boost your online presence with the simple
                  addition of catalogs and categories. Streamline product
                  organization, ensuring customers can easily explore and
                  uncover your offerings for a seamless shopping experience.
                </p>
              </div>
              <div className="function-container">
                <h2>Share your digital store</h2>
                <div className="line2"></div>
                <p>
                  Effortlessly share your digital store with your target
                  audience. Expand your online reach, engage customers, and
                  boost sales by easily promoting your business.
                </p>
              </div>
              <div className="function-container">
                <h2>And many more...</h2>
                <div className="line2"></div>
                <p>
                  With the Bazaar app, your possibilities are endless. In
                  addition to adding clients, creating orders, and designing
                  business cards, you can explore a wealth of other versatile
                  features that cater to all your business needs and beyond.
                </p>
              </div>
            </div>

            <div className="bazaar-ecommerce-container">
              <div className="bazaar-ecommerce-poster" data-aos="fade-right">
                <img src={img6} alt="Ecommerce" />
              </div>
              <div className="bazaar-ecommerce-text" data-aos="fade-left">
                <h3>Explore Bazaar Ecommerce</h3>
                <div className="line2"></div>
                <p>
                  Our platform lets users easily discover stores and their
                  catelogs and categories, streamlining the shopping experience.
                  Find your favorite businesses and their offerings effortlessly
                  within our ecosystem.
                </p>
              </div>
            </div>

            <div className="bazaar-function-text">
              <h1 data-aos="zoom-out-up">Bazaar Digital Storefront</h1>
              <div className="line" data-aos="zoom-out-up"></div>
              <img src={img7} alt="Demo storefront" data-aos="zoom-in" />

              <h3 data-aos="fade-up">
                Experience a Sample Digital Store on Our Demo Account{" "}
                <button onClick={() => handleDemo()}>View Demo</button>
              </h3>
            </div>

            <div className="qr-code-main-container">
              <img src={img8} alt="qrcode" data-aos="zoom-in" />
              <h3 data-aos="fade-up">Scan the QR code to download our app</h3>
            </div>

            <div className="bazaar-function-text">
              <h1 data-aos="zoom-out-up">Contact Us</h1>
              <div className="line" data-aos="zoom-out-up"></div>
            </div>
            <div className="bazaar-main-container" data-aos="zoom-in">
              <div className="bazaar-main-box">
                <div className="bazaar-contact-section">
                  <h1>We'd love to hear from you!</h1>
                  <h4>You can contact us at:</h4>
                  <ul className="bazaar-info-list">
                    <li>
                      <strong>
                        <BsFillTelephoneFill className="bazaar-contact-icon" />
                      </strong>
                      <a
                        style={{ textDecoration: "none" }}
                        href="tel:+91-8474874094"
                      >
                        +918474874094
                      </a>
                    </li>
                    <li>
                      <strong>
                        <BsSendFill className="bazaar-contact-icon" />
                      </strong>
                      <a
                        style={{ textDecoration: "none" }}
                        href="mailto:support@bazaarapp.in"
                      >
                        support@bazaarapp.in
                      </a>
                    </li>
                  </ul>
                  <div className="bazaar-social-icons">
                    <h2>Connect With Us</h2>
                    <div className="bazaar-icons">
                      <a
                        href="https://www.facebook.com/mybazaarapp"
                        className="bazaar-icon"
                      >
                        <BsFacebook className="bazaar-social-icon" />
                      </a>
                      <a
                        href="https://instagram.com/bazaarapp.in?igshid=MzRlODBiNWFlZA=="
                        className="bazaar-icon"
                      >
                        <BsInstagram className="bazaar-social-icon" />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/bazaarapp/"
                        className="bazaar-icon"
                      >
                        <BsLinkedin className="bazaar-social-icon" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="bazaar-contact-form">
                  <h1>Please feel free to share your thoughts with us!</h1>
                  <form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                    <input
                      type="tel"
                      maxLength={10}
                      placeholder="Phone"
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                    <input
                      type="email"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <textarea
                      placeholder="Message"
                      onChange={(e) => setMsg(e.target.value)}
                      required
                    ></textarea>
                    <input className="submit-button" type="submit" />
                  </form>
                </div>
              </div>
            </div>

            <div className="bazaar-home-footer">
              <div className="footer-logo-container">
                <img src={logo} alt="" />
              </div>
              <div className="footer-text-container">
                <p>#BazaarForBharat</p>
                <p>Made with &#10084;&#65039; in Bharat</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Home;
